import {
  apiRequest,
  skpTunjanganKhususList,
  exportExcel,
  masterWorkUnit,
  listAtasan,
  skpTunjanganKhususDetail,
} from "../../../../../services/adapters/kepegawaian/skpTunjanganKhususService";

class DataTableRepository {
  fetchDetail = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      skpTunjanganKhususDetail,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      skpTunjanganKhususList,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchWorkUnit = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      masterWorkUnit,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchAtasan = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      listAtasan,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchExport = async (query) => {
    return await apiRequest(
      "get",
      exportExcel,
      {
        params: query,
      },
      true
    );
  };
}
export default DataTableRepository;
